import { _, helpers, React, ts, ui } from '_core';

import { transform } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  definition: ts.types.signal.Lasso;
  file: string;
  fullScreen: boolean;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, file, definition, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: { file },
      });
      if (response) {
        const newData = _.map(response.data, (row) => ({
          ..._.omit(row, 'build_date'),
          date: row.build_date,
        }));
        setData(transform(newData, definition));
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  const customDownloadFormatting = (lData: ts.types.widgets.TableData) => {
    const localData = helpers.csv.transpose(lData as any, 'date', 'var');
    return localData.map((row) => {
      const newRow = { var: row['var'] } as typeof row;
      // Add dates in order
      _.without(Object.keys(row), 'var')
        .reverse()
        .forEach((date) => {
          newRow[date] = row[date];
        });
      return newRow;
    });
  };

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      customDownloadFormatting={customDownloadFormatting}
      exportTitle={title}
      yAxisLabel="Signal Weights"
      xAxisLabel="Time"
      numberFormat="#.##%"
    />
  );
};

export default Chart;
